import { getHumanReadableNameCellHelper } from "../../../../../../../utils";

import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (
	item: Order.Model["orderToCarClasses"],
	language: Language,
): string =>
	Array.isArray(item)
		? item
				.map((it) =>
					getHumanReadableNameCellHelper(
						it?.carClass?.name,
						language,
					),
				)
				.filter((v): v is string => Boolean(v))
				.join(", ")
		: "";

export default cellProcessing;
